export default class CollapseAndDestructListener {
    constructor(selector = '.collapse-and-destruct') {
        document.addEventListener("DOMContentLoaded", function (event) {

            document.querySelectorAll(selector).forEach(element => {
                element.addEventListener('show.bs.collapse', function (event) {
                    CollapseAndDestructListener.prototype.collapseAndDestruct(this);
                });
            });
        });
    }

    collapseAndDestruct(element) {
        let collapseId = element.id;
        let collapseButton = document.querySelector('[aria-controls="' + collapseId + '"]');
        collapseButton.classList.add('collapse');
    }
}